<!--
Author: zhangkun
Date: 2024-05-08
Desc: 转换列表和赎回转申购列表
 -->
<template>
    <div>
        <el-table
            v-if="load"
            :data="fundAll"
            style="width: 100%"
            class="tab-list-tit table"
            :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
        >
            <el-table-column label="产品名称" width="280" class-name="fund-offset">
                <template slot-scope="scope">
                    <div class="c_333 fs14" v-on:click.stop="gotoDetail(scope.row)">
                        {{ scope.row.fundname }}
                    </div>
                    <div class="c_999 fs14">
                        {{ scope.row.fundcode }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="销售机构" align="center">
                <template slot-scope="scope">
                    <div class="c_333 fs14">
                        {{ scope.row.distributorname }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="最新净值" align="center">
                <template slot-scope="scope">
                    <div class="c_333 fs14">
                        {{ $util.fmtNum(scope.row.nav, 4) }}
                    </div>
                    <div class="c_999 fs12">
                        {{ $util.fmtDate(scope.row.navdate) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="收费方式" align="center">
                <template slot-scope="scope">
                    <div class="c_333 fs14">
                        {{
                            scope.row.sharetype == "0"
                                ? "前收费"
                                : scope.row.sharetype == "1"
                                ? "后收费"
                                : ""
                        }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="分红方式" align="center">
                <template slot-scope="scope">
                    <div class="c_333 fs14">
                        {{
                            scope.row.dividendmethoddetail
                                ? $cache.getDict("90273", scope.row.dividendmethoddetail)
                                : "--"
                        }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="持有份额" align="center">
                <template slot-scope="scope">
                    <div class="c_333 fs14">
                        {{ $util.fmtNum(scope.row.currentshare) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="持仓金额（元）" align="center">
                <template slot-scope="scope">
                    <div class="c_333 fs14">
                        {{ $util.fmtNum(scope.row.marketvalue) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-tooltip
                        v-if="checkTrusteeship(scope.row)"
                        class="item"
                        effect="info"
                        :content="checkTrusteeship(scope.row)"
                        placement="top"
                    >
                        <el-button type="text" disabled size="small">转托管</el-button>
                    </el-tooltip>
                    <el-button
                        v-else
                        type="text"
                        plain
                        size="small"
                        v-on:click.stop="trusteeship(scope.row)"
                    >
                        转托管
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > 0" class="page-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="pageRefresh"
            />
        </el-row>
    </div>
</template>

<script>
import fundApi from "@/api/fund";
export default {
    name: "TrusteeshipList",
    components: {},
    data() {
        return {
            fundAll: [],
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            curPage: 1, // 当前页
            conf: {}, // 初始化配置文件内容
            load: false
        };
    },
    created() {
        this.conf = this.$util.getConfig().const;
    },
    methods: {
        // 切换分页
        pageRefresh(val) {
            this.pageoffset = val;
            this.getList();
        },
        getList() {
            // producttype 默认查询全部@，中台配置为z时代表只有REITs产品支持
            let fundshowtype = "";
            if (
                this.$cache.getParamValue("trade_info") &&
                this.$cache.getParamValue("trade_info").combTrusteeAlllimit
            ) {
                fundshowtype = this.$cache.getParamValue("trade_info").combTrusteeAlllimit;
            }
            fundApi
                .getAssetsList({
                    producttype: "@",
                    fundshowtype: fundshowtype,
                    transferagencystatus: "0,2",
                    pageSize: this.pagecount,
                    pageNum: this.pageoffset
                })
                .then((res) => {
                    this.load = true;
                    if (this.pageoffset == 1) {
                        this.curPage = 1;
                    }
                    this.fundAll = res.data.returnList ? res.data.returnList : [];
                    this.fundAll.forEach((fund) => {
                        fund.isChange = this.$util.checkChange(fund);
                        if (fund.dividendmethod == "0") {
                            // 红利再投资
                            fund.dividendmethoddetail = "3";
                        } else {
                            if (fund.dividendcashbacktype == "1") {
                                // 自动充值至钱柜
                                fund.dividendmethoddetail = "1";
                            } else {
                                // 发放至银行卡
                                fund.dividendmethoddetail = "2";
                            }
                        }
                    });
                    this.allPage = res.data.total ? res.data.total.toString() : "0";
                });
        },
        // 点击转托管按钮
        trusteeship(fund) {
            const _x = Object.assign({}, fund);
            sessionStorage.setItem("trusteeshipFund", JSON.stringify(_x));
            this.$router.push({
                name: "trusteeshipFund",
                query: { fundcode: fund.fundcode }
            });
        },
        checkTrusteeship(fund) {
            if (fund.tano !== "98" && fund.tano !== "99") {
                return "该基金不支持跨系统转托管";
            }
            if (fund.transferusevol <= 0) {
                return "基金可用份额为0，不能托管";
            }
            return "";
        }
    }
};
</script>

<style lang="scss" scoped>
.table {
    margin-top: 20px;
}
.fund-name {
    color: var(--color-text-primary);
    font-size: 14px;
    cursor: pointer;
}
.el-button.is-plain:hover,
.el-button.is-plain:focus,
.el-button.is-disabled.is-plain {
    background-color: transparent;
    border-color: transparent;
}

.el-button--text {
    font-size: 14px;
    font-weight: normal;
    color: var(--color-primary);
}
.el-button--text.is-disabled {
    color: var(--color-text-weak);
}

::v-deep .el-select > .el-input {
    font-size: 16px;
    color: blue;
}
.el-table {
    border: 1px solid var(--color-divided);
}
.el-table--fit {
    margin-bottom: 15px;
}
.el-pagination {
    margin-bottom: 0;
}
</style>
